import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { observer } from 'mobx-react-lite';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Popper from '@material-ui/core/Popper';
import Fade from '@material-ui/core/Fade';
import styles from './PopperWrapper.module.css';

const useStyles = makeStyles({
  popper: {
    zIndex: 99,
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: '-4px',
      marginLeft: '-5px',
      width: '7px',
      height: '7px',
      '&::before': {
        borderWidth: '0 7px 5px 5px',
        borderColor: `transparent transparent #fff transparent`,
      },
    },
    '&[x-placement*="top"] $arrow': {
      bottom: 0,
      left: 0,
      marginBottom: '-5px',
      marginLeft: '-5px',
      width: '6px',
      height: '6px',
      '&::before': {
        borderWidth: '6px 4px 0 4px',
        borderColor: `#fff transparent transparent transparent`,
      },
    },
    '&[x-placement*="right"] $arrow': {
      left: 0,
      marginLeft: '-5px',
      height: '6px',
      width: '6px',
      '&::before': {
        borderWidth: '4px 6px 4px 0',
        borderColor: `transparent #fff transparent transparent`,
      },
    },
    '&[x-placement*="left"] $arrow': {
      right: 0,
      marginRight: '-5px',
      height: '6px',
      width: '6px',
      '&::before': {
        borderWidth: '4px 0 4px 6px',
        borderColor: `transparent transparent transparent #fff`,
      },
      // d0d5e1
    },
  },
  arrow: {
    position: 'absolute',
    fontSize: 7,
    width: '7px',
    height: '7px',
    zIndex: '1',
    '&::before': {
      content: '""',
      margin: 'auto',
      display: 'block',
      width: 0,
      height: 0,
      borderStyle: 'solid',
    },
  },
});

// eslint-disable-next-line prefer-arrow-callback,sonarjs/cognitive-complexity
const PopperWrapper = observer(function PopperWrapper(props) {
  const { isOpen, anchorEl, arrow, arrowDirection, children, onClose, containerClass } = props;
  const [arrowRef, setArrowRef] = React.useState(null);
  const classes = useStyles();

  return (
    <ClickAwayListener mouseEvent="onMouseDown" onClickAway={onClose}>
      <Popper
        open={isOpen}
        anchorEl={anchorEl}
        placement={arrowDirection}
        disablePortal={false}
        modifiers={{
          flip: {
            enabled: true,
          },
          preventOverflow: {
            enabled: arrow,
            boundariesElement: 'viewport',
          },
          arrow: {
            enabled: true,
            element: arrowRef,
          },
        }}
        className={classes.popper}
      >
        <Fade in={isOpen}>
          <div className={[styles.positionRelative, containerClass].join(' ')}>
            <span className={classes.arrow} ref={setArrowRef} />
            {children}
          </div>
        </Fade>
      </Popper>
    </ClickAwayListener>
  );
});
PopperWrapper.whyDidYouRender = true;
PopperWrapper.displayName = 'PopperWrapper';

export default PopperWrapper;
